import React from 'react'
import './FaqList.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons'
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

const FaqList = () => {

    // === FAQS DATA ===
    const faqsData = [
        {
            title: 'How do I plan a party using the Elite Partyz App?',
            content: 'You can create an event, invite friends, create a to do list, set a budget and find suppliers.  You are also able to buy, hire and rent products and services from suppliers through the app.',
        },
        {
            title: ' Is the app free?',
            content: 'Yes our app is free for all people creating events. There is no hidden costs within the app. You have access to all the amazing features our app has to offer.',
        },
        {
            title: 'What type of party can I plan using the app?',
            content: 'You can create any event, party, function imaginable. Our tools and access to suppliers makes it even easier to keep within your budget, chat with suppliers, buy, rent or hire products and services from your favourite suppliers.',
        },
        {
            title: 'Can I invite my favourite suppliers?',
            content: 'You will be able invite suppliers to download the app. This will make it easier to access their products, services and chat.',
        },
        {
            title: 'How do I manage my budget on the app?',
            content: 'You will be able to manually edit your budget, set budget amount, view budget summary, review cost amounts, paid amounts and amounts owing.',
        },
    ]
    return (
        <div className="faq-list">
            <div className="container">
                <div className="faq-content">
                    <Accordion allowZeroExpanded>
                        {faqsData.map((item, index) => (
                            <AccordionItem key={`TOGGLE${index}`}>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                    <FontAwesomeIcon icon={faCaretRight} />{item.title}
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                {item.content}
                                </AccordionItemPanel>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </div>
    )
}

export default FaqList
